class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items') || this.closest('mini-cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus') || document.getElementById('MiniCart-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if(!event.target.matches(".cart-size-select") && !event.target.matches(".input-quantity"))
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-count',
        section: 'cart-icon-count',
        selector: '#cart-icon-count',
      },
      {
        id: 'cart-icon-count-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#cart-icon-count-footer',
      },
      {
        id: 'cart-promo-code-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#cart-promo-code-footer',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '#cart-live-region-text'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, fromEdit = false, noRender = false) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    return new Promise((res,rej)=>{
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        let quantityElement = null;
        
        !fromEdit ? quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`) || document.getElementById(`MiniCart-quantity-${line}`)
        : quantityElement = document.querySelector(`.input-quantity-${line}`);

        const items = document.querySelectorAll('.cart-item').length > 0 ? document.querySelectorAll('.cart-item') : document.querySelectorAll('.mini-cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        
       
    
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (!noRender) {
          this.renderSection(parsedState);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }

        this.updateLiveRegions(line, message);

        if (!noRender) {
          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`) || document.getElementById(`MiniCart-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
       }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        res(state);
      })
      .catch((e) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors') || document.getElementById('MiniCart-CartErrors');
        errors.textContent = window.cartStrings.error;
        rej(e);
      })
      .finally(() => {
        this.disableLoading(line);
      });
    })
    
  }

  renderSection(state){
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace ? elementToReplace.innerHTML = this.getSectionInnerHTML(
        state.sections[section.section],
        section.selector
      ) : null;
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`) || document.getElementById(`MiniCart-LineItemError-${line}`);

    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText') || document.getElementById('MiniCart-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems') || document.getElementById('MiniCart-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems') || document.getElementById('MiniCart-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// creo un custom element che estende cart items e lo chiamo promocode, lo vado a mettere sullo snippet dell'apply discount

class CartEdit extends CartItems {
  constructor() {
    super();
    this.item = this.getItemData();
    this.allVariants = JSON.parse(this.querySelector("script.all-variants").innerText);
    this.defaultOptions = JSON.parse(this.querySelector("script.option-values").innerText);
    this.line = this.dataset.line;
    this.newItem = null;
    this.cartDialog = this.querySelector('#editCart');
    this.cartButtons = this.querySelector('.edit-cart-open');
    this.buttonCartClose = this.querySelector('#ModalClose');
    this.selectSize = this.querySelector('.cart-size-select');
    this.option = this.selectSize.querySelector('option');
    this.selectColor = this.querySelector('.cart-size-select');
    this.inputQuantity = this.querySelector('.input-quantity');
   
    this.setDefaultSize();
    this.setDefaultColor();
    this.bindEvents();

  }

  // connectedCallback(){
    
  // }

  bindEvents() {
    this.cartButtons.addEventListener('click', (e) => {
      e.preventDefault();
      this.openDialog();
    })

    this.cartDialog.addEventListener('click', this.handleClick.bind(this));
    this.selectSize.addEventListener("change", this.updateData.bind(this));
    //this.inputQuantity.addEventListener("change", this.updateData.bind(this));

  }

  getDefaultSize(){
   return this.defaultOptions.size;
  }

  getDefaultColor(){
   return this.defaultOptions.color;
  }

  getSizeValue(){
    return this.querySelector('.cart-size-select').value.toLowerCase();
  }

  getColorValue(){
    return this.querySelector('.tw-color-swatch--active')?.dataset.swatchColor;
  }

  getQuantity(){
    return this.querySelector(".input-quantity").value;
  }

  getItemData(){
    return JSON.parse(this.querySelector('script.actual-variant').innerText);
  }

  setDefaultSize(){
    this.selectSize.value = this.getDefaultSize();
  }
  setDefaultColor(){
    const swatchToSelect = this.querySelector(`[data-swatch-color='${this.getDefaultColor()}']`);
    this.handleSwatchSelected(swatchToSelect);
  }

  setItemData(id, quantity){
    this.newItem = {
      "id" : id,
      "quantity" : parseInt(quantity)
    };
    //chiami ogni volta che cambi qualcosa nel popup 
    //this.item.id = id
    // this.item.quantity = quantity

  }

  findVariant(color, size){
    // effettuare il controllo su color se presente all'interno di return
    //Object.entries(this.allVariants).map()
    const id = Object.entries(this.allVariants)
    .find(([key, value]) => {
      return (value.option1 === size || value.option1 === color) &&
             (value.option2 === size || value.option2 === color);
    })?.[1].id || null;
  
    return id;
  }

  updateData(e) {
    e.preventDefault();
    let newQuantity = this.getQuantity();
    let newColor = this.getColorValue();
    let newSize = this.getSizeValue();
    let newVariant = this.findVariant(newColor, newSize);
    this.setItemData(newVariant, newQuantity);
    const availableVariant = this.checkAvailability(newVariant);
    if (availableVariant == false) {
      this.disableUpdateButton();
    } else {
      this.enableUpdateButton();
    }
  }

  disableUpdateButton(){
    const updateButtons = document.querySelectorAll('.update-button');
    updateButtons.forEach((updateButton) => {
      updateButton.classList.add('variant-out-of-stock');
      updateButton.innerHTML="out of stock";
      updateButton.disabled = true;
    })
  }
  enableUpdateButton(){
    const updateButtons = document.querySelectorAll('.update-button');
    updateButtons.forEach((updateButton) => {
      updateButton.classList.remove('variant-out-of-stock');
      updateButton.innerHTML="update product";
      updateButton.disabled = false; 
    })
   
  }

  checkAvailability(variantId){
    const availability = Object.entries(this.allVariants)
    .find(([key, value]) => {
      return (value.id === variantId);
    })?.[1].available || false;
    return availability;
  }

  openDialog() {
    this.cartDialog.showModal();
    let overflowBody = document.querySelector('body');
    overflowBody.classList.add('tw-overflow-hidden');
    this.cartDialog.classList.remove('tw-opacity-0');
  }

  closeDialog(){
    let overflowBody = document.querySelector('body');
    overflowBody.classList.remove('tw-overflow-hidden');
    this.cartDialog.classList.add('tw-opacity-0');
    this.cartDialog.close();
  }


  handleClick(event) {
    // If the target dialog is
    if (event.target.matches('#ModalClose, #ModalClose * ')){
      this.closeDialog();
    }
    if(event.target.contains(this.cartDialog)){
      this.closeDialog();
    }
    if(event.target.matches('.color-swatch-img-wrapper, .color-swatch-img-wrapper * ')){
      this.handleSwatchSelected(event.target);
      this.updateData(event);
    }
    if (event.target.matches('.update-button, .update-button *')) {
      event.preventDefault();
      // let error = handleError();
      this.closeDialog();
      if(this.newItem != null)
        this.handleUpdate();
    }
  }

  // handleError(){
  //   let available = false;
  //   let newQuantity = this.getQuantity();
  //   let newColor = this.getColorValue();
  //   let newSize = this.getSizeValue();
  //   available = this.isVariantAvailable(newColor, newSize);
    
  //   return isError;
  // }

  handleSwatchSelected(target){
    const swatchClass = ".color-swatch-img-wrapper";
    this.querySelectorAll(swatchClass).forEach(el =>{
      if(el.closest(swatchClass).classList.contains('tw-color-swatch--active'))
        el.closest(swatchClass).classList.remove('tw-color-swatch--active');
    })
    if (target?.closest(swatchClass)) {
      if(!target.closest(swatchClass).classList.contains('tw-color-swatch--active'))
      target.closest(swatchClass).classList.add('tw-color-swatch--active');
    }
  }
   
  handleUpdate(){
    const noChange = this.noChange();
    if(!noChange){
      const variantChange = this.isVariantChange();
      if(variantChange){
        this.updateProduct();
        return;
      }
      this.updateQuantity(this.line, this.newItem.quantity, null, this.newItem.id, true, false);
     
    }
    
  }

  async updateProduct(){

    try {
      await this.removeProduct();
    } catch (err) { console.log(err) }

    try {
      const addState = await this.addProduct();
      this.renderSection(addState);
    } catch (err) { console.log(err) }
    
  }

  addProduct(){
    const id = this.newItem.id;
    const quantity = this.newItem.quantity;
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    return new Promise((res,rej)=>{
      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        res(parsedState);
      })
      .catch((error) => {
        console.error('Error:', error);
        rej(error);
      }); 
    })
  }

  removeProduct(){
    return this.updateQuantity(this.line, 0, null, this.newItem.id, true, true);
  }

  noChange(){
    return this.areObjectsEqual(this.newItem, this.item);
  }

  isVariantChange(){
    //confronta i due oggetti e return true se variant id diverso
    if (this.newItem.id === this.item.id) {
      return false;
    }
    return true;
  }

  areObjectsEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) {
      return false;
    }
  
    for (const key of keys1) {
      if (!obj2.hasOwnProperty(key)) {
        return false;
      }
  
      const value1 = obj1[key];
      const value2 = obj2[key];
  
      if (typeof value1 === 'object' && typeof value2 === 'object') {
        if (!areObjectsEqual(value1, value2)) {
          return false;
        }
      } else if (value1 !== value2) {
        return false;
      }
    }
  
    return true;
  }
}

customElements.define('cart-edit', CartEdit);

class CartToCheckout extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('#CheckboxToCheckout');
    this.paymentWrapper = this.querySelector("#wrapper-payments");
    this.checkoutBtn = this.querySelector("#checkout");
    //this.morePaymentOptionsDetails = this.querySelector('more-payment-options details');
  }

  connectedCallback() {
    subscribe(PUB_SUB_EVENTS.loadedPayments, ()=>{
      this.firstCheck();
    })
    this.checkboxClick();
    this.handleNotification();
  }

  handleNotification(){
    this.addEventListener("click", (e)=>{
      if(!this.checkbox.checked){
        this.viewNotification(e);
      }
    })
  }

  viewNotification(e){
    if(e.target.matches(".btn-container") || e.target.matches("more-payment-options")){
      const checkWrap = this.querySelector(".checkout-button-container");
      checkWrap.classList.add("display-error");
    }
  }

  firstCheck(){
    if (this.checkbox.checked) {
      this.enablePayments();
    }
  }

  checkboxClick() {
    if (this.checkbox) {
      this.checkbox.addEventListener('click', (event) => {
        if (this.checkbox.checked) {
          this.enablePayments();
        } else {
          this.disablePayments();
        }
      });
    }
  }

  enablePayments(){
    this.querySelector(".checkout-button-container").classList.remove("display-error");
    this.paymentWrapper.classList = "";
    this.checkoutBtn.classList.remove("tw-disabled");
  }

  disablePayments(){
    this.paymentWrapper.classList.add("tw-pointer-events-none", "tw-opacity-[.5]");
    this.checkoutBtn.classList.add("tw-disabled");
  }
}

customElements.define('cart-to-checkout', CartToCheckout);